import { useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import notify from 'devextreme/ui/notify';
import {
  DataGrid, Column, Selection, SearchPanel, HeaderFilter, Search, Editing,
} from 'devextreme-react/data-grid';
import { appConst } from '~/app-const';
import { CreateAuthorizedStore } from '~/helpers/data';

export function Explorer(props) {
  let explorerGridRef = useRef();

  const { visible, emailToData } = props;

  const campaignsDS = CreateAuthorizedStore(
    {
      loadUrl: `${window.env.apiEndpoint}/api/v1/DistributionList/GetCampaigns`,
      deleteUrl: `${window.env.apiEndpoint}/api/v1/DistributionList/DeleteCampaign`
    },
    { load: { to: emailToData } }, 'Id');

  return (
    <>
      <Popup
        visible={visible}
        title="Emails..."
        height="75%"
        width="75%"
        showCloseButton={true} 
        onHiding={
          () => {
            props.setShowExplorer(false);
          }
        }
      >
        <DataGrid
          id="explorerGrid"
          ref={explorerGridRef}
          {...appConst.defaultGridOptions}
          remoteOperations={false}
          height="100%"
          dataSource={campaignsDS}
          onRowDblClick={(e) => {
            const ds = CreateAuthorizedStore(
              { loadUrl: `${window.env.apiEndpoint}/api/v1/DistributionList/GetCampaign` },
              { load: { Id: e.key } },
            );
            ds.load().then(
              (data) => {
                props.updateEmailClient(data[0].Html, data[0].From, data[0].Subject, data[0].FromText, data[0].To, data[0].CampaignId, data[0].Status);
              },
              (error) => {
                notify({ message: error.message, shading: true }, 'error');
              }
            );
          }}
        >
          <Editing
            allowAdding={false}
            allowDeleting={true}
            allowUpdating={false}
          />
          <Selection mode="single" />
          <SearchPanel
            visible
            width={240}
            placeholder="Search..."
          />
          <HeaderFilter
            visible
          >
            <Search enabled={true}/>
          </HeaderFilter>
          <Column
            dataField="Id"
            dataType="text"
            caption="ID"
          />
          <Column
            dataField="Title"
            dataType="text"
            caption="Title"
          />
          <Column
            dataField="From"
            dataType="text"
            caption="From"
          />
          <Column
            dataField="To"
            dataType="text"
            caption="To"
          />
          <Column
            dataField="FolderName"
            dataType="text"
            caption="Folder"
          />
          <Column
            dataField="Status"
            dataType="text"
            caption="Status"
          />
          <Column
            dataField="CreateDate"
            dataType="datetime"
            caption="Create Date"
            format={appConst.dateAndTimeDisplayFormat}
          />
          <Column
            dataField="SentDate"
            dataType="datetime"
            caption="Sent Date"
            format={appConst.dateAndTimeDisplayFormat}
          />
        </DataGrid>
      </Popup>
    </>
  );
}

